import script from "./bi-tmpl-add-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./bi-tmpl-add-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./bi-tmpl-add-dialog.vue?vue&type=style&index=0&id=14e49b02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e49b02"]])

export default __exports__